(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7599],{

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 5247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)("div").withConfig({
  displayName: "DiscountPromo__StyledContainer",
  componentId: "sc-ei00og-0"
})(["display:flex;align-items:center;padding:8px;border-radius:4px;border:1px solid #ffbc0d;background:#fffaeb;width:fit-content;min-height:36px;"]);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "DiscountPromo__StyledText",
  componentId: "sc-ei00og-1"
})(["color:#000;font-family:NarkisBlock;font-size:18px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:0.27px;display:flex;align-items:center;"]);

var DiscountPromo = function DiscountPromo(_ref) {
  var promoText = _ref.promoText;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledContainer, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledText, {
      children: promoText
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DiscountPromo);

/***/ }),

/***/ 92208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(282);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var StyledButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "GenericButton__StyledButtonContainer",
  componentId: "sc-r0056q-0"
})(["width:", ";", " ", " height:48px;", "{width:", ";", "}display:flex;justify-content:center;align-items:center;border-radius:8px;padding:8px 16px;font-family:NarkisBlock;font-size:24px;color:var(--Black,var(--Primary-Black,#000));cursor:pointer;", " ", " ", " ", ""], function (p) {
  return p !== null && p !== void 0 && p.$width ? "".concat(p === null || p === void 0 ? void 0 : p.$width, "px") : "328px";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$width) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$fullWidth) && "width: 100%;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p !== null && p !== void 0 && p.$mobileWidth ? "".concat(p === null || p === void 0 ? void 0 : p.$mobileWidth, "px") : "100%";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "filled" && !(p !== null && p !== void 0 && p.$disabled) && "\n      background: var(--Yellow, #ffbc0d);\n\n      &:hover {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n        background: var(--Yellow, #ffbc0d);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: #F5B511;\n      }\n    ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "outlined" && !(p !== null && p !== void 0 && p.$disabled) && "\n      border: 2px solid var(--Yellow, #FFBC0D);\n      background: var(--White, #FFF);\n\n\n      &:hover {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n        background: var(--White, #FFF);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: rgba(247, 247, 247, 0.50);\n      }\n  ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$disabled) && "\n      background: var(--Light-Grey, #F7F7F7);\n      color: rgba(45, 45, 45, 0.72);\n    ";
}, function (p) {
  return p.isdisabled && "\n    background: var(--Light-Grey, #f7f7f7);\n    color: rgba(45, 45, 45, 0.72);\n    font-size: 24px;\n    :hover {\n    background: var(--Light-Grey, #f7f7f7);\n\n  }\n  ";
});
var StyledIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "GenericButton__StyledIcon",
  componentId: "sc-r0056q-1"
})([""]);

var GenericButton = function GenericButton(_ref) {
  var btnType = _ref.btnType,
      width = _ref.width,
      mobileWidth = _ref.mobileWidth,
      icon = _ref.icon,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      endIcon = _ref.endIcon,
      fullWidth = _ref.fullWidth,
      buttonHref = _ref.buttonHref,
      isdisabled = _ref.isdisabled;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButtonContainer, {
    $width: width,
    $mobileWidth: mobileWidth,
    $btnType: btnType,
    $disabled: disabled,
    $fullWidth: fullWidth,
    onClick: onClick,
    disabled: disabled,
    type: type,
    isdisabled: isdisabled,
    className: className,
    href: buttonHref,
    children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: icon
    }), children, endIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: endIcon
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GenericButton);

/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var SvgComponent = function SvgComponent() {
  var w = 31;
  var h = 31;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "back arrow",
    width: w,
    height: h,
    viewBox: "0 0 31 31",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
      "data-name": "Ellipse 6",
      cx: "15.5",
      cy: "15.5",
      r: "15.5",
      fill: "#f7f7f7"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "data-name": "Path 603",
      d: "M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 44203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledContainer",
  componentId: "sc-mrb9q4-0"
})(["display:", ";position:fixed;z-index:1500;margin:0 auto;width:100%;", "{top:10px;}"], function (p) {
  return p !== null && p !== void 0 && p.hidden ? "none" : "block";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledNavContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledNavContainer",
  componentId: "sc-mrb9q4-1"
})(["padding:15px;background:", ";border:3px solid ", ";border-radius:3px;"], function (p) {
  return p.theme.colors.grey;
}, function (p) {
  return p.theme.colors.cherryRed;
});
var StyledDescription = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "KeyboardNavigation__StyledDescription",
  componentId: "sc-mrb9q4-2"
})(["text-align:center;font-size:25px;margin:0;padding:0;"]);

var KeyboardNavigation = function KeyboardNavigation(_ref) {
  var refList = _ref.refList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      hideNav = _useState[0],
      setHideNav = _useState[1]; // Ensures that this component will only show once


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      seenOnce = _useState2[0],
      setSeenOnce = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleKeyDown(e) {
      if (!(e !== null && e !== void 0 && e.key) || seenOnce) return;

      if (e.key === "Tab") {
        e.preventDefault();

        if (hideNav) {
          setHideNav(false);
          return;
        }

        if (!hideNav) {
          setSeenOnce(true);
          setHideNav(true);
          return;
        }
      }

      if (!hideNav && e.key === "Enter") {
        var _refList$, _refList$$current, _refList$2, _refList$2$current;

        (_refList$ = refList[0]) === null || _refList$ === void 0 ? void 0 : (_refList$$current = _refList$.current) === null || _refList$$current === void 0 ? void 0 : _refList$$current.scrollIntoView();
        (_refList$2 = refList[0]) === null || _refList$2 === void 0 ? void 0 : (_refList$2$current = _refList$2.current) === null || _refList$2$current === void 0 ? void 0 : _refList$2$current.focus();
        setSeenOnce(true);
        setHideNav(!hideNav);
      } // Old code that allowed you to navigate to different blocks
      // matches digits 0 - 9
      // if (!hideNav && e.key.match(/^\d+$/)) {
      // refList[e.key - 1]?.current?.scrollIntoView()
      // refList[e.key - 1]?.current?.focus()
      // }

    }

    document.addEventListener("keydown", handleKeyDown); // Clean up event

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [hideNav]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
    hidden: hideNav,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNavContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDescription, {
        children: "\u05D3\u05DC\u05D2 \u05DC\u05EA\u05D5\u05DB\u05DF"
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (KeyboardNavigation);

/***/ }),

/***/ 16110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["href", "passHref", "children", "openInNewTab", "noScrollToTop", "ariaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var NextLink = function NextLink(_ref) {
  var href = _ref.href,
      passHref = _ref.passHref,
      children = _ref.children,
      _ref$openInNewTab = _ref.openInNewTab,
      openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
      _ref$noScrollToTop = _ref.noScrollToTop,
      noScrollToTop = _ref$noScrollToTop === void 0 ? false : _ref$noScrollToTop,
      ariaLabel = _ref.ariaLabel,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  // const { asPath } = useRouter()
  // const idx = asPath.indexOf("?")
  // const search = idx >= 0 ? asPath.slice(idx) : undefined
  // const link: UrlObject = {
  //   pathname: href,
  //   // search
  //  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    scroll: !noScrollToTop,
    children: openInNewTab ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
      target: "_blank",
      rel: "noreferrer"
    }, props), {}, {
      "aria-label": ariaLabel,
      children: children
    })) : passHref ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({}, props), {}, {
      "aria-label": ariaLabel,
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(NextLink));

/***/ }),

/***/ 86897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ quick_purchase; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./components/KeyboardNavigation/KeyboardNavigation.tsx
var KeyboardNavigation = __webpack_require__(44203);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./components/BackButton/BackButton.tsx
var BackButton = __webpack_require__(36166);
// EXTERNAL MODULE: ./components/DiscountPromo/DiscountPromo.tsx
var DiscountPromo = __webpack_require__(5247);
// EXTERNAL MODULE: ./components/GenericButton/GenericButton.tsx
var GenericButton = __webpack_require__(92208);
// EXTERNAL MODULE: ./components/GenericInput/GenericInput.tsx
var GenericInput = __webpack_require__(9108);
// EXTERNAL MODULE: ./components/OtpStep/OtpContext.tsx
var OtpContext = __webpack_require__(78461);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/PageTitle/PageTitle.tsx



var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h1",
  variant: "h2"
}).withConfig({
  displayName: "PageTitle__StyledTitle",
  componentId: "sc-10ud4jy-0"
})(["color:#000;text-align:right;font-family:NarkisBlock;font-size:40px;font-style:normal;font-weight:bold;line-height:normal;max-width:500px;", " ", " ", "{width:100%;", " ", "}"], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$padding) && "padding: ".concat(p.$padding, ";");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$margin) && "margin: ".concat(p.$margin, ";");
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobilePadding) && "padding: ".concat(p.$mobilePadding, ";");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileMargin) && "margin: ".concat(p.$mobileMargin, ";");
});

var PageTitle = function PageTitle(_ref) {
  var ref = _ref.ref,
      titleText = _ref.titleText;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
    ref: ref,
    children: titleText
  });
};

/* harmony default export */ var PageTitle_PageTitle = (PageTitle);
// EXTERNAL MODULE: ./components/PurchasePage/GroupPurchasesContext.tsx
var GroupPurchasesContext = __webpack_require__(28218);
// EXTERNAL MODULE: ./components/PurchasePage/LegalCheckboxes.tsx + 3 modules
var LegalCheckboxes = __webpack_require__(40839);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(33574);
// EXTERNAL MODULE: ./components/Reusable/Bit/Form/FormikForm.tsx
var FormikForm = __webpack_require__(34968);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
;// CONCATENATED MODULE: ./components/QuickPurchasePage/Form/FormSectionTitle.tsx




var SectionContainer = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "FormSectionTitle__SectionContainer",
  componentId: "sc-1ernw5x-0"
})(["display:flex;align-items:center;gap:16px;", "{gap:8px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledImg = (0,styled_components_browser_esm/* default */.ZP)("img").withConfig({
  displayName: "FormSectionTitle__StyledImg",
  componentId: "sc-1ernw5x-1"
})(["width:56px;height:56px;", "{width:40px;height:40px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var FormSectionTitle_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h2"
}).withConfig({
  displayName: "FormSectionTitle__StyledTitle",
  componentId: "sc-1ernw5x-2"
})(["color:#000;font-family:NarkisBlock;font-size:32px;font-style:normal;font-weight:bold;line-height:normal;letter-spacing:0.48px;", "{font-size:24px;letter-spacing:0.36px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var FormSectionTitle = function FormSectionTitle(_ref) {
  var imgSrc = _ref.imgSrc,
      imgAlt = _ref.imgAlt,
      titleText = _ref.titleText;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SectionContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledImg, {
      src: imgSrc,
      alt: imgAlt
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormSectionTitle_StyledTitle, {
      children: titleText
    })]
  });
};

/* harmony default export */ var Form_FormSectionTitle = (FormSectionTitle);
// EXTERNAL MODULE: ./components/Reusable/Bit/FormikSchema.ts
var FormikSchema = __webpack_require__(39163);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/QuickPurchasePage/Form/validationSchema.ts



var validationSchema = function validationSchema(_ref) {
  var min = _ref.min,
      max = _ref.max;
  return es/* object */.Ry({
    amount: es/* number */.Rx().min(min, "\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05D9\u05E0\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC \u05DC\u05E4\u05D7\u05D5\u05EA ".concat(min, " \u05E9\u05F4\u05D7")).max(max, "\u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05DB\u05E0\u05D9\u05E1 \u05E1\u05DB\u05D5\u05DD \u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9 \u05E9\u05DC ".concat(max, " \u05E9\u05F4\u05D7")).typeError("יש להזין מספר בלבד").required(FormikSchema/* required.default */.C1["default"]),
    RecipientName: FormikSchema/* schemaCommon.fullName */.Cr.fullName,
    RecipientMobilePhone: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
    RecipientEmail: FormikSchema/* schemaCommon.recipientEmail */.Cr.recipientEmail,
    SenderName: FormikSchema/* schemaCommon.fullName */.Cr.fullName,
    SenderLastName: FormikSchema/* schemaCommon.fullName */.Cr.fullName,
    SenderMobilePhone: FormikSchema/* schemaCommon.phoneNumber */.Cr.phoneNumber,
    SenderEmail: FormikSchema/* schemaCommon.email */.Cr.email,
    checkedOne: FormikSchema/* schemaCommon.checkbox */.Cr.checkbox
  });
};

/* harmony default export */ var Form_validationSchema = (validationSchema);
// EXTERNAL MODULE: ./components/QuickPurchasePage/QuickPurchaseContext.tsx
var QuickPurchaseContext = __webpack_require__(98968);
;// CONCATENATED MODULE: ./components/QuickPurchasePage/QuickPurchaseProcess.tsx

























var RECAPTCHA_KEY = "6LdBc5YiAAAAABjC-OWsg7BFb01Rd-j-nwJcXLx-";

if (!RECAPTCHA_KEY) {
  throw new Error("Please provide the RECAPTCHA_KEY environment variable.");
}

var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "QuickPurchaseProcess__StyledWrapper",
  componentId: "sc-ulupg2-0"
})(["padding:108px 60px 80px 60px;display:flex;flex-direction:column;gap:48px;", "{padding:76px 16px 40px 16px;gap:32px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledTitleBox = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "QuickPurchaseProcess__StyledTitleBox",
  componentId: "sc-ulupg2-1"
})(["display:flex;gap:24px;", "{flex-direction:column;gap:8px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledSection = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "QuickPurchaseProcess__StyledSection",
  componentId: "sc-ulupg2-2"
})(["display:flex;flex-direction:column;", "{margin-bottom:30px;}", "{align-items:flex-start;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledRow = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "QuickPurchaseProcess__StyledRow",
  componentId: "sc-ulupg2-3"
})(["display:flex;justify-content:space-between;gap:24px;", "{flex-direction:column;gap:0;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledFormContainer = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "QuickPurchaseProcess__StyledFormContainer",
  componentId: "sc-ulupg2-4"
})(["display:flex;flex-direction:column;", "{gap:48px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSmallInputContainer = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "QuickPurchaseProcess__StyledSmallInputContainer",
  componentId: "sc-ulupg2-5"
})(["display:flex;gap:24px;", "{gap:16px;> *{width:100%;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledCheckboxContainer = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "QuickPurchaseProcess__StyledCheckboxContainer",
  componentId: "sc-ulupg2-6"
})(["display:flex;justify-content:space-between;align-items:center;"]);
var StyledSubmitButton = (0,styled_components_browser_esm/* default */.ZP)(GenericButton/* default */.Z).attrs({
  variant: "contained"
}).withConfig({
  displayName: "QuickPurchaseProcess__StyledSubmitButton",
  componentId: "sc-ulupg2-7"
})(["display:flex;width:328px;height:48px;padding:8px 16px;justify-content:center;align-items:center;gap:4px;border-radius:8px;background:var(--Yellow,#ffbc0d);color:#000;", "{display:none;}", ""], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.isdisabled && "\n    background: var(--Light-Grey, #f7f7f7);\n    color: rgba(45, 45, 45, 0.72);\n    font-size: 24px;\n    :hover {\n    background: var(--Light-Grey, #f7f7f7);\n\n  }\n  ";
});
var StyledForm = (0,styled_components_browser_esm/* default */.ZP)("div").withConfig({
  displayName: "QuickPurchaseProcess__StyledForm",
  componentId: "sc-ulupg2-8"
})([""]);
var timeoutId;

var debounce = function debounce(func, value) {
  clearTimeout(timeoutId);
  timeoutId = setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            func(value);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 1000);
};

var QuickPurchaseProcess = function QuickPurchaseProcess(_ref2) {
  var _settings$promotion;

  var settings = _ref2.settings;

  var _useState = (0,react.useState)(null),
      checkboxValues = _useState[0],
      setCheckboxValues = _useState[1];

  var _useGroupPurchasesCon = (0,GroupPurchasesContext/* useGroupPurchasesContext */.ZA)(),
      setPrevPath = _useGroupPurchasesCon.setPrevPath;

  var reCaptchaRef = /*#__PURE__*/(0,react.createRef)();

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      setSelectedGiftCard = _usePurchaseContext.setSelectedGiftCard,
      setPurchaseGiftCardPrice = _usePurchaseContext.setGiftCardPrice,
      setPurchaseData = _usePurchaseContext.setPurchaseData;

  var _useQuickPurchaseCont = (0,QuickPurchaseContext/* useQuickPurchaseContext */.Nr)(),
      quickPurchaseInputValues = _useQuickPurchaseCont.quickPurchaseInputValues,
      setPriceAfterDiscount = _useQuickPurchaseCont.setPriceAfterDiscount,
      setshowStickyBottom = _useQuickPurchaseCont.setshowStickyBottom,
      setValidationPassed = _useQuickPurchaseCont.setValidationPassed,
      setSubmitFormTrigger = _useQuickPurchaseCont.setSubmitFormTrigger,
      setQuickPurchaseInputValues = _useQuickPurchaseCont.setQuickPurchaseInputValues,
      setShowExitModal = _useQuickPurchaseCont.setShowExitModal,
      setDiscount = _useQuickPurchaseCont.setDiscount,
      giftCardPrice = _useQuickPurchaseCont.giftCardPrice,
      setGiftCardPrice = _useQuickPurchaseCont.setGiftCardPrice;

  var _useOtpContext = (0,OtpContext/* useOtpContext */.yQ)(),
      setTotalTimeoutInSeconds = _useOtpContext.setTotalTimeoutInSeconds,
      setPhoneNumber = _useOtpContext.setPhoneNumber;

  var router = (0,next_router.useRouter)();

  var getVerificationCode = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(phone, gRecaptchaResponse) {
      var response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0,api.postGiftCardGenerateVerificationCode)({
                mobilePhone: phone.replace(/-/g, ""),
                toSendSms: true,
                gRecaptchaResponse: gRecaptchaResponse
              });

            case 3:
              response = _context2.sent;

              if ((response === null || response === void 0 ? void 0 : response.status) === 200 && response !== null && response !== void 0 && response.data) {
                setTotalTimeoutInSeconds(response.data.body.totalTimeoutInSeconds);
                router.push("/quick-purchase/otp");
              }

              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
              router.replace("/404");

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function getVerificationCode(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSubmit = function handleSubmit(values, recaptchaResponse) {
    setQuickPurchaseInputValues(values);
    var purchaseDataObj = {
      quantity: 1,
      amount: values === null || values === void 0 ? void 0 : values.amount,
      phoneNumber: values === null || values === void 0 ? void 0 : values.RecipientMobilePhone,
      recipientName: values === null || values === void 0 ? void 0 : values.RecipientName,
      recipientEmail: values === null || values === void 0 ? void 0 : values.RecipientEmail,
      giftCardTypeId: 0,
      blessingId: 0,
      senderName: values === null || values === void 0 ? void 0 : values.SenderName,
      senderLastName: values === null || values === void 0 ? void 0 : values.SenderName,
      senderMobilePhone: values === null || values === void 0 ? void 0 : values.SenderMobilePhone,
      senderEmail: values === null || values === void 0 ? void 0 : values.SenderEmail,
      senderBlessing: "senderBlessing",
      approveMarketingContent: values === null || values === void 0 ? void 0 : values.checkedTwo,
      messagesScheduleDate: ""
      /* date-time */
      ,
      allowanceStartDateTime: ""
      /* date-time */
      ,
      allowanceEndDateTime: ""
      /* date-time */
      ,
      giftCardScheduleType: "",
      audioBlessingBase64: "",
      audioBlessingContentType: "",
      audioBlessingExtension: "",
      audioDuration: 0,
      videoFileId: "",
      aiImageGuid: ""
    }; // Set it here so that it can be used in PurchaseSummaryPage and rest of flow

    setPurchaseData(purchaseDataObj); // For the OTP form

    var phone = values === null || values === void 0 ? void 0 : values.SenderMobilePhone.replace(/-/g, "");
    setPhoneNumber(phone);
    getVerificationCode(phone, recaptchaResponse);
    router.push("/quick-purchase/otp");
  };

  var tmpFormik;
  (0,react.useEffect)(function () {
    if (giftCardPrice > 0) {
      debounce(sendToServer, giftCardPrice); // Stops formik from resetting value on submit

      tmpFormik.setFieldValue("amount", giftCardPrice);
    } // Set so that the back button on Terms page works


    setPrevPath("/quick-purchase");
  }, []);
  var amount = quickPurchaseInputValues.amount,
      RecipientName = quickPurchaseInputValues.RecipientName,
      RecipientMobilePhone = quickPurchaseInputValues.RecipientMobilePhone,
      RecipientEmail = quickPurchaseInputValues.RecipientEmail,
      SenderName = quickPurchaseInputValues.SenderName,
      SenderLastName = quickPurchaseInputValues.SenderLastName,
      SenderMobilePhone = quickPurchaseInputValues.SenderMobilePhone,
      SenderEmail = quickPurchaseInputValues.SenderEmail;
  var initialValues = {
    amount: amount || "",
    RecipientName: RecipientName || "",
    RecipientMobilePhone: RecipientMobilePhone || "",
    RecipientEmail: RecipientEmail || "",
    SenderName: SenderName || "",
    SenderLastName: SenderLastName || "",
    SenderMobilePhone: SenderMobilePhone || "",
    SenderEmail: SenderEmail || "",
    checkedOne: false,
    checkedTwo: false
  }; // Shows Stick Bottom Summary

  (0,react.useEffect)(function () {
    setshowStickyBottom(true);
    setSubmitFormTrigger(function () {
      var _tmpFormik;

      return (_tmpFormik = tmpFormik) === null || _tmpFormik === void 0 ? void 0 : _tmpFormik.submitForm;
    });
    setSelectedGiftCard({
      id: settings === null || settings === void 0 ? void 0 : settings.blessingId,
      categoryId: 0,
      // ?
      name: settings === null || settings === void 0 ? void 0 : settings.blessingSlug,
      order: 0,
      image: {
        imageUrl: "",
        // ?
        alt: "" // ?

      },
      blessingType: "",
      // ?
      blessingScheduleTypeDefault: "",
      // ?
      promotion: settings === null || settings === void 0 ? void 0 : settings.promotion,
      slug: settings === null || settings === void 0 ? void 0 : settings.blessingSlug,
      pageTitle: "",
      // ?
      metaTitle: "",
      // ?
      keywords: "",
      // ?
      metaDescription: "",
      // ?
      isAiImage: false
    });
    return function () {
      setshowStickyBottom(false);
    };
  }, []);

  var saveGiftCardData = function saveGiftCardData(values) {
    // Will be used in future dev
    setQuickPurchaseInputValues(values);
    setGiftCardPrice(parseInt(values === null || values === void 0 ? void 0 : values.amount));
    setPurchaseGiftCardPrice(parseInt(values === null || values === void 0 ? void 0 : values.amount));
  };

  var sendToServer = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(value) {
      var _response$data, _response$data$body, _response$data2, _response$data2$body;

      var response;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0,api.postGiftCardCalculatePrice)({
                quantity: 1,
                amount: value,
                blessingId: settings === null || settings === void 0 ? void 0 : settings.blessingId,
                allowanceStartDateTime: "",
                allowanceEndDateTime: "",
                giftCardScheduleType: "None"
              });

            case 2:
              response = _context3.sent;
              setDiscount(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : _response$data$body.decreasePercentage);
              setPriceAfterDiscount(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$body = _response$data2.body) === null || _response$data2$body === void 0 ? void 0 : _response$data2$body.price);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function sendToServer(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var setFormikValidation = function setFormikValidation(errors) {
    if (Object.keys(errors).length === 0 && checkboxValues !== null && checkboxValues !== void 0 && checkboxValues.checkedOne) {
      setValidationPassed(true);
      return;
    }

    setValidationPassed(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackButton/* default */.Z, {
          prevPath: "/quick-purchase",
          linkText: "\u05D7\u05D6\u05E8\u05D4",
          padding: "12px 0 0 0",
          mobilePadding: "18px 0 0 0",
          preventNavigation: true,
          beforeNavigation: function beforeNavigation() {
            return setShowExitModal(true);
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTitleBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageTitle_PageTitle, {
          titleText: "\u05D2\u05D9\u05E4\u05D8\u05E7\u05D0\u05E8\u05D3 \u05E9\u05DC \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3'\u05E1"
        }), (settings === null || settings === void 0 ? void 0 : settings.promotion) && /*#__PURE__*/(0,jsx_runtime.jsx)(DiscountPromo/* default */.Z, {
          promoText: settings === null || settings === void 0 ? void 0 : (_settings$promotion = settings.promotion) === null || _settings$promotion === void 0 ? void 0 : _settings$promotion.description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledForm, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
          validationSchema: Form_validationSchema({
            min: settings === null || settings === void 0 ? void 0 : settings.minamuont,
            max: settings === null || settings === void 0 ? void 0 : settings.maxAmuont
          }),
          initialValues: initialValues,
          onSubmit: /*#__PURE__*/function () {
            var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(values) {
              var _reCaptchaRef$current, _reCaptchaRef$current2;

              var recaptchaResponse;
              return regenerator_default().wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current = reCaptchaRef.current) === null || _reCaptchaRef$current === void 0 ? void 0 : _reCaptchaRef$current.reset();
                      _context4.next = 3;
                      return reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current2 = reCaptchaRef.current) === null || _reCaptchaRef$current2 === void 0 ? void 0 : _reCaptchaRef$current2.executeAsync();

                    case 3:
                      recaptchaResponse = _context4.sent;
                      handleSubmit(values, recaptchaResponse);

                    case 5:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x4) {
              return _ref5.apply(this, arguments);
            };
          }(),
          render: function render(formik) {
            tmpFormik = formik;
            setFormikValidation(formik === null || formik === void 0 ? void 0 : formik.errors);
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledFormContainer, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form_FormSectionTitle, {
                  imgSrc: "/mcdonalds-logo-confetti.svg",
                  imgAlt: "McDonalds Confetti Logo",
                  titleText: "\u05DB\u05DE\u05D4 \u05D1\u05D0 \u05DC\u05DA \u05DC\u05EA\u05EA?"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                  name: "amount",
                  label: "\u05D4\u05D6\u05E0\u05EA \u05E1\u05DB\u05D5\u05DD",
                  type: "tel",
                  topMargin: "24",
                  mobileTopMargin: "8",
                  inputMode: "numeric",
                  onChange: /*#__PURE__*/function () {
                    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(e) {
                      var value;
                      return regenerator_default().wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              formik.handleChange(e);
                              value = e.target.value;

                              if (value === "") {
                                formik.setFieldValue("amount", "");
                              } else {
                                formik.setFieldValue("amount", parseInt(value));
                              }

                              debounce(sendToServer, parseInt(value));

                            case 4:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function (_x5) {
                      return _ref6.apply(this, arguments);
                    };
                  }()
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form_FormSectionTitle, {
                  imgSrc: "/gift-box.svg",
                  imgAlt: "McDonalds Gift Box",
                  titleText: "\u05DC\u05DE\u05D9 \u05D4\u05DE\u05EA\u05E0\u05D4?"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledRow, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                    name: "RecipientName",
                    label: "\u05E9\u05DD/\u05E9\u05DD \u05D7\u05D9\u05D1\u05D4 (*\u05D7\u05D5\u05D1\u05D4)",
                    $width: "328",
                    topMargin: "24",
                    mobileTopMargin: "8"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                    name: "RecipientMobilePhone",
                    label: "\u05DE\u05E1\u05E4\u05E8 \u05E0\u05D9\u05D9\u05D3 (*\u05D7\u05D5\u05D1\u05D4)",
                    $width: "328",
                    type: "tel",
                    topMargin: "24",
                    mobileTopMargin: "8"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                    name: "RecipientEmail",
                    label: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC (\u05E8\u05E9\u05D5\u05EA)",
                    $width: "328",
                    type: "email",
                    topMargin: "24",
                    mobileTopMargin: "8"
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Form_FormSectionTitle, {
                  imgSrc: "/mobile-phone.svg",
                  imgAlt: "McDonalds Mobile Phone",
                  titleText: "\u05D4\u05E4\u05E8\u05D8\u05D9\u05DD \u05E9\u05DC\u05D9 \u05DC\u05EA\u05E9\u05DC\u05D5\u05DD"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledRow, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSmallInputContainer, {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                      name: "SenderName",
                      label: "\u05E9\u05DD \u05E4\u05E8\u05D8\u05D9 (*\u05D7\u05D5\u05D1\u05D4)",
                      $width: "156",
                      autoComplete: "given-name",
                      topMargin: "24",
                      mobileTopMargin: "8"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                      name: "SenderLastName",
                      label: "\u05E9\u05DD \u05DE\u05E9\u05E4\u05D7\u05D4 (*\u05D7\u05D5\u05D1\u05D4)",
                      $width: "156",
                      autoComplete: "family-name",
                      topMargin: "24",
                      mobileTopMargin: "8"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                    name: "SenderMobilePhone",
                    label: "\u05DE\u05E1\u05E4\u05E8 \u05E0\u05D9\u05D9\u05D3 (*\u05D7\u05D5\u05D1\u05D4)",
                    $width: "328",
                    type: "tel",
                    autoComplete: "tel-national",
                    topMargin: "24",
                    mobileTopMargin: "8"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(GenericInput/* GenericInput */.j, {
                    name: "SenderEmail",
                    label: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC (*\u05D7\u05D5\u05D1\u05D4)",
                    $width: "328",
                    type: "email",
                    autoComplete: "email",
                    topMargin: "24",
                    mobileTopMargin: "8"
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCheckboxContainer, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LegalCheckboxes/* default */.Z, {
                  saveGiftCardData: saveGiftCardData,
                  margin: "0",
                  setValues: setCheckboxValues
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSubmitButton, {
                  btnType: "filled",
                  type: "submit",
                  isdisabled: Object.keys(formik === null || formik === void 0 ? void 0 : formik.errors).length > 0 || !(checkboxValues !== null && checkboxValues !== void 0 && checkboxValues.checkedOne),
                  children: "\u05D4\u05DB\u05DC \u05E0\u05DB\u05D5\u05DF, \u05D4\u05DC\u05D0\u05D4"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
                ref: reCaptchaRef,
                sitekey: RECAPTCHA_KEY,
                size: "invisible",
                hl: "iw",
                tabIndex: -1
              })]
            });
          }
        })
      })]
    })
  });
};

/* harmony default export */ var QuickPurchasePage_QuickPurchaseProcess = (QuickPurchaseProcess);
;// CONCATENATED MODULE: ./src/pages/quick-purchase/index.tsx








var QuickPurchase = function QuickPurchase(_ref) {
  var settings = _ref.settings,
      seo = _ref.seo;

  var _useState = (0,react.useState)([]),
      refList = _useState[0];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(KeyboardNavigation/* default */.Z, {
      refList: refList
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuickPurchasePage_QuickPurchaseProcess, {
      settings: settings === null || settings === void 0 ? void 0 : settings.body
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var quick_purchase = (QuickPurchase);

/***/ }),

/***/ 98976:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase",
      function () {
        return __webpack_require__(86897);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2726,2198,7072,4733,7870,9774,2888,179], function() { return __webpack_exec__(98976); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);